export default "__VITE_ASSET__536e69b7__"